import React, { useState, useRef, useEffect } from "react";
import { useLang } from "../i18n/LanguageContext";

export const CITY_LIST: string[] = [
  // 특별시·광역시
  "서울특별시", "부산광역시", "대구광역시", "인천광역시",
  "광주광역시", "대전광역시", "울산광역시", "세종특별자치시",
  // 경기도
  "수원시", "성남시", "용인시", "고양시", "부천시", "안양시",
  "남양주시", "화성시", "안산시", "파주시", "의정부시", "평택시",
  "시흥시", "광명시", "김포시", "하남시", "오산시", "이천시",
  "군포시", "과천시", "의왕시", "안성시", "여주시", "양주시",
  "구리시", "동두천시", "포천시", "양평군", "가평군", "연천군",
  // 강원특별자치도
  "춘천시", "원주시", "강릉시", "속초시", "동해시", "삼척시",
  "태백시", "홍천군", "철원군", "평창군", "정선군", "영월군",
  "인제군", "고성군", "양구군",
  // 충청북도
  "청주시", "충주시", "제천시", "진천군", "음성군", "증평군",
  "괴산군", "보은군", "옥천군", "영동군", "단양군",
  // 충청남도
  "천안시", "아산시", "공주시", "홍성군", "보령시", "서산시",
  "논산시", "당진시", "예산군", "태안군", "계룡시", "금산군",
  "부여군", "청양군", "서천군",
  // 전라북도
  "전주시", "군산시", "익산시", "정읍시", "남원시", "김제시",
  "완주군", "진안군", "무주군", "임실군", "순창군", "고창군", "부안군",
  // 전라남도
  "목포시", "순천시", "여수시", "나주시", "광양시",
  "담양군", "고흥군", "해남군", "장흥군", "보성군",
  "강진군", "완도군", "진도군", "신안군",
  // 경상북도
  "포항시", "경주시", "안동시", "구미시", "영주시", "경산시",
  "김천시", "상주시", "문경시", "영천시", "칠곡군",
  "의성군", "군위군", "청송군", "영덕군", "울진군",
  "봉화군", "예천군", "청도군", "고령군", "성주군", "영양군", "울릉군",
  // 경상남도
  "창원시", "진주시", "통영시", "거제시", "양산시", "밀양시",
  "김해시", "사천시", "함안군", "거창군", "합천군",
  "고성군", "남해군", "하동군", "산청군", "함양군", "의령군", "창녕군",
  // 제주특별자치도
  "제주시", "서귀포시",

  // 일본
  "도쿄", "오사카", "나고야", "후쿠오카", "삿포로", "교토",
  "고베", "히로시마", "센다이", "나하",
  // 중국
  "베이징", "상하이", "광저우", "선전", "청두", "충칭",
  "시안", "우한", "난징", "항저우",
  // 대만·홍콩
  "홍콩", "마카오", "타이베이", "타이중", "가오슝",
  // 동남아시아
  "방콕", "치앙마이", "싱가포르", "쿠알라룸푸르", "페낭",
  "자카르타", "발리", "수라바야", "마닐라", "세부",
  "하노이", "호치민", "다낭", "양곤", "프놈펜", "비엔티안",
  // 남아시아
  "뉴델리", "뭄바이", "콜카타", "방갈로르", "첸나이",
  "하이데라바드", "다카", "카라치", "이슬라마바드", "콜롬보", "카트만두",
  // 중앙아시아
  "타슈켄트", "알마티", "아스타나", "비슈케크", "두샨베",
  // 중동
  "두바이", "아부다비", "도하", "리야드", "이스탄불",
  "앙카라", "테헤란", "바그다드", "베이루트", "암만",
  // 유럽
  "런던", "파리", "베를린", "마드리드", "바르셀로나",
  "로마", "밀라노", "암스테르담", "브뤼셀", "취리히",
  "비엔나", "뮌헨", "함부르크", "코펜하겐", "스톡홀름",
  "오슬로", "헬싱키", "더블린", "리스본", "아테네",
  "부다페스트", "프라하", "바르샤바", "모스크바", "상트페테르부르크",
  "키이우",
  // 북미
  "뉴욕", "로스앤젤레스", "시카고", "댈러스", "휴스턴",
  "워싱턴DC", "보스턴", "필라델피아", "마이애미", "애틀랜타",
  "샌프란시스코", "시애틀", "포틀랜드", "덴버", "피닉스",
  "라스베이거스", "샌디에이고", "미니애폴리스",
  "토론토", "밴쿠버", "몬트리올", "캘거리", "오타와",
  "멕시코시티",
  // 남미
  "상파울루", "리우데자네이루", "부에노스아이레스",
  "보고타", "리마", "산티아고", "브라질리아", "카라카스",
  // 오세아니아
  "시드니", "멜버른", "브리즈번", "퍼스", "애들레이드",
  "골드코스트", "캔버라", "오클랜드", "웰링턴", "크라이스트처치",
  // 아프리카
  "카이로", "나이로비", "요하네스버그", "케이프타운",
  "라고스", "아디스아바바", "카사블랑카", "다카르",
  // 몽골
  "울란바토르",
];

// 한글 도시명 → 영문 표기 (영어 검색·표시용). 저장/전송값은 항상 한글(백엔드·시간보정 로직이 한글명 사용).
const CITY_EN: Record<string, string> = {
  "서울특별시": "Seoul", "부산광역시": "Busan", "대구광역시": "Daegu", "인천광역시": "Incheon",
  "광주광역시": "Gwangju", "대전광역시": "Daejeon", "울산광역시": "Ulsan", "세종특별자치시": "Sejong",
  "수원시": "Suwon", "성남시": "Seongnam", "용인시": "Yongin", "고양시": "Goyang", "부천시": "Bucheon",
  "안양시": "Anyang", "남양주시": "Namyangju", "화성시": "Hwaseong", "안산시": "Ansan", "파주시": "Paju",
  "의정부시": "Uijeongbu", "평택시": "Pyeongtaek", "시흥시": "Siheung", "광명시": "Gwangmyeong",
  "김포시": "Gimpo", "하남시": "Hanam", "오산시": "Osan", "이천시": "Icheon", "군포시": "Gunpo",
  "과천시": "Gwacheon", "의왕시": "Uiwang", "안성시": "Anseong", "여주시": "Yeoju", "양주시": "Yangju",
  "구리시": "Guri", "동두천시": "Dongducheon", "포천시": "Pocheon", "양평군": "Yangpyeong",
  "가평군": "Gapyeong", "연천군": "Yeoncheon", "춘천시": "Chuncheon", "원주시": "Wonju", "강릉시": "Gangneung",
  "속초시": "Sokcho", "동해시": "Donghae", "삼척시": "Samcheok", "태백시": "Taebaek", "홍천군": "Hongcheon",
  "철원군": "Cheorwon", "평창군": "Pyeongchang", "정선군": "Jeongseon", "영월군": "Yeongwol", "인제군": "Inje",
  "고성군": "Goseong", "양구군": "Yanggu", "청주시": "Cheongju", "충주시": "Chungju", "제천시": "Jecheon",
  "진천군": "Jincheon", "음성군": "Eumseong", "증평군": "Jeungpyeong", "괴산군": "Goesan", "보은군": "Boeun",
  "옥천군": "Okcheon", "영동군": "Yeongdong", "단양군": "Danyang", "천안시": "Cheonan", "아산시": "Asan",
  "공주시": "Gongju", "홍성군": "Hongseong", "보령시": "Boryeong", "서산시": "Seosan", "논산시": "Nonsan",
  "당진시": "Dangjin", "예산군": "Yesan", "태안군": "Taean", "계룡시": "Gyeryong", "금산군": "Geumsan",
  "부여군": "Buyeo", "청양군": "Cheongyang", "서천군": "Seocheon", "전주시": "Jeonju", "군산시": "Gunsan",
  "익산시": "Iksan", "정읍시": "Jeongeup", "남원시": "Namwon", "김제시": "Gimje", "완주군": "Wanju",
  "진안군": "Jinan", "무주군": "Muju", "임실군": "Imsil", "순창군": "Sunchang", "고창군": "Gochang",
  "부안군": "Buan", "목포시": "Mokpo", "순천시": "Suncheon", "여수시": "Yeosu", "나주시": "Naju",
  "광양시": "Gwangyang", "담양군": "Damyang", "고흥군": "Goheung", "해남군": "Haenam", "장흥군": "Jangheung",
  "보성군": "Boseong", "강진군": "Gangjin", "완도군": "Wando", "진도군": "Jindo", "신안군": "Sinan",
  "포항시": "Pohang", "경주시": "Gyeongju", "안동시": "Andong", "구미시": "Gumi", "영주시": "Yeongju",
  "경산시": "Gyeongsan", "김천시": "Gimcheon", "상주시": "Sangju", "문경시": "Mungyeong", "영천시": "Yeongcheon",
  "칠곡군": "Chilgok", "의성군": "Uiseong", "군위군": "Gunwi", "청송군": "Cheongsong", "영덕군": "Yeongdeok",
  "울진군": "Uljin", "봉화군": "Bonghwa", "예천군": "Yecheon", "청도군": "Cheongdo", "고령군": "Goryeong",
  "성주군": "Seongju", "영양군": "Yeongyang", "울릉군": "Ulleung", "창원시": "Changwon", "진주시": "Jinju",
  "통영시": "Tongyeong", "거제시": "Geoje", "양산시": "Yangsan", "밀양시": "Miryang", "김해시": "Gimhae",
  "사천시": "Sacheon", "함안군": "Haman", "거창군": "Geochang", "합천군": "Hapcheon", "남해군": "Namhae",
  "하동군": "Hadong", "산청군": "Sancheong", "함양군": "Hamyang", "의령군": "Uiryeong", "창녕군": "Changnyeong",
  "제주시": "Jeju", "서귀포시": "Seogwipo",
  "도쿄": "Tokyo", "오사카": "Osaka", "나고야": "Nagoya", "후쿠오카": "Fukuoka", "삿포로": "Sapporo",
  "교토": "Kyoto", "고베": "Kobe", "히로시마": "Hiroshima", "센다이": "Sendai", "나하": "Naha",
  "베이징": "Beijing", "상하이": "Shanghai", "광저우": "Guangzhou", "선전": "Shenzhen", "청두": "Chengdu",
  "충칭": "Chongqing", "시안": "Xian", "우한": "Wuhan", "난징": "Nanjing", "항저우": "Hangzhou",
  "홍콩": "Hong Kong", "마카오": "Macau", "타이베이": "Taipei", "타이중": "Taichung", "가오슝": "Kaohsiung",
  "방콕": "Bangkok", "치앙마이": "Chiang Mai", "싱가포르": "Singapore", "쿠알라룸푸르": "Kuala Lumpur",
  "페낭": "Penang", "자카르타": "Jakarta", "발리": "Bali", "수라바야": "Surabaya", "마닐라": "Manila",
  "세부": "Cebu", "하노이": "Hanoi", "호치민": "Ho Chi Minh City", "다낭": "Da Nang", "양곤": "Yangon",
  "프놈펜": "Phnom Penh", "비엔티안": "Vientiane", "뉴델리": "New Delhi", "뭄바이": "Mumbai", "콜카타": "Kolkata",
  "방갈로르": "Bangalore", "첸나이": "Chennai", "하이데라바드": "Hyderabad", "다카": "Dhaka", "카라치": "Karachi",
  "이슬라마바드": "Islamabad", "콜롬보": "Colombo", "카트만두": "Kathmandu", "타슈켄트": "Tashkent",
  "알마티": "Almaty", "아스타나": "Astana", "비슈케크": "Bishkek", "두샨베": "Dushanbe", "두바이": "Dubai",
  "아부다비": "Abu Dhabi", "도하": "Doha", "리야드": "Riyadh", "이스탄불": "Istanbul", "앙카라": "Ankara",
  "테헤란": "Tehran", "바그다드": "Baghdad", "베이루트": "Beirut", "암만": "Amman", "런던": "London",
  "파리": "Paris", "베를린": "Berlin", "마드리드": "Madrid", "바르셀로나": "Barcelona", "로마": "Rome",
  "밀라노": "Milan", "암스테르담": "Amsterdam", "브뤼셀": "Brussels", "취리히": "Zurich", "비엔나": "Vienna",
  "뮌헨": "Munich", "함부르크": "Hamburg", "코펜하겐": "Copenhagen", "스톡홀름": "Stockholm", "오슬로": "Oslo",
  "헬싱키": "Helsinki", "더블린": "Dublin", "리스본": "Lisbon", "아테네": "Athens", "부다페스트": "Budapest",
  "프라하": "Prague", "바르샤바": "Warsaw", "모스크바": "Moscow", "상트페테르부르크": "Saint Petersburg",
  "키이우": "Kyiv", "뉴욕": "New York", "로스앤젤레스": "Los Angeles", "시카고": "Chicago", "댈러스": "Dallas",
  "휴스턴": "Houston", "워싱턴DC": "Washington DC", "보스턴": "Boston", "필라델피아": "Philadelphia",
  "마이애미": "Miami", "애틀랜타": "Atlanta", "샌프란시스코": "San Francisco", "시애틀": "Seattle",
  "포틀랜드": "Portland", "덴버": "Denver", "피닉스": "Phoenix", "라스베이거스": "Las Vegas",
  "샌디에이고": "San Diego", "미니애폴리스": "Minneapolis", "토론토": "Toronto", "밴쿠버": "Vancouver",
  "몬트리올": "Montreal", "캘거리": "Calgary", "오타와": "Ottawa", "멕시코시티": "Mexico City",
  "상파울루": "Sao Paulo", "리우데자네이루": "Rio de Janeiro", "부에노스아이레스": "Buenos Aires",
  "보고타": "Bogota", "리마": "Lima", "산티아고": "Santiago", "브라질리아": "Brasilia", "카라카스": "Caracas",
  "시드니": "Sydney", "멜버른": "Melbourne", "브리즈번": "Brisbane", "퍼스": "Perth", "애들레이드": "Adelaide",
  "골드코스트": "Gold Coast", "캔버라": "Canberra", "오클랜드": "Auckland", "웰링턴": "Wellington",
  "크라이스트처치": "Christchurch", "카이로": "Cairo", "나이로비": "Nairobi", "요하네스버그": "Johannesburg",
  "케이프타운": "Cape Town", "라고스": "Lagos", "아디스아바바": "Addis Ababa", "카사블랑카": "Casablanca",
  "다카르": "Dakar", "울란바토르": "Ulaanbaatar",
};

interface Props {
  value: string;
  onChange: (v: string) => void;
  inputStyle?: React.CSSProperties;
  disabled?: boolean;
}

export function CityAutocomplete({ value, onChange, inputStyle, disabled }: Props) {
  const { t, lang } = useLang();
  const [query, setQuery]   = useState(value);
  const [open, setOpen]     = useState(false);
  const wrapRef             = useRef<HTMLDivElement>(null);

  // 영어 모드에선 저장된 한글값을 영문 라벨로 표시(값 자체는 한글 유지)
  const cityLabel = (ko: string) => (lang === "en" && CITY_EN[ko]) ? CITY_EN[ko] : ko;

  useEffect(() => { setQuery(value ? cityLabel(value) : ""); }, [value, lang]);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const q  = query.trim();
  const ql = q.toLowerCase();
  const matches = q.length >= 1
    ? CITY_LIST.filter(c => c.includes(q) || (CITY_EN[c] || "").toLowerCase().includes(ql)).slice(0, 10)
    : [];

  const select = (city: string) => {
    onChange(city);            // 저장/전송값은 항상 한글
    setQuery(cityLabel(city)); // 표시는 언어에 맞춰
    setOpen(false);
  };

  return (
    <div ref={wrapRef} style={{ position: "relative", width: "100%" }}>
      <input
        value={query}
        disabled={disabled}
        placeholder={t("city.placeholder")}
        style={{
          width: "100%",
          padding: "10px 12px",
          border: "1.5px solid #e0d5c8",
          borderRadius: 10,
          fontSize: "0.9rem",
          color: "#3d2b1f",
          background: disabled ? "#f5f0ea" : "#fdfaf7",
          fontFamily: "inherit",
          cursor: disabled ? "not-allowed" : "text",
          outline: "none",
          ...inputStyle,
        }}
        onChange={e => { setQuery(e.target.value); setOpen(true); }}
        onFocus={() => { if (query.length >= 1) setOpen(true); }}
        onKeyDown={e => {
          if (e.key === "Escape") setOpen(false);
          if (e.key === "Enter" && matches.length === 1) { select(matches[0]); e.preventDefault(); }
        }}
      />
      {open && matches.length > 0 && (
        <div style={{
          position: "absolute",
          top: "calc(100% + 4px)",
          left: 0, right: 0,
          background: "#fff",
          border: "1.5px solid #c09a6b",
          borderRadius: 10,
          boxShadow: "0 6px 20px rgba(100,70,40,0.15)",
          zIndex: 200,
          maxHeight: 220,
          overflowY: "auto",
        }}>
          {matches.map((city, i) => (
            <div
              key={city}
              onMouseDown={() => select(city)}
              style={{
                padding: "9px 14px",
                cursor: "pointer",
                fontSize: "0.88rem",
                color: "#3d2b1f",
                borderBottom: i < matches.length - 1 ? "1px solid #f0e8df" : "none",
                transition: "background 0.1s",
              }}
              onMouseEnter={e => (e.currentTarget.style.background = "#fff8f2")}
              onMouseLeave={e => (e.currentTarget.style.background = "transparent")}
            >
              {cityLabel(city)}
            </div>
          ))}
        </div>
      )}
      <div style={{
        fontSize: "0.72rem",
        color: "#9c7b5a",
        marginTop: 4,
        lineHeight: 1.5,
      }}>
        {t("city.hintPre")}<strong>{t("city.hintStrong")}</strong>{t("city.hintPost")}
      </div>
    </div>
  );
}
